<!--
  * name: NewsList
  * description: 뉴스 페이지 컴포넌트
-->
<template>
  <div class="container list-style-mo">
    <div class="srch-wrap list-style-mo--except">
      <search-box
        class="srch-wrap-box"
        ref="searchBox"
        placeholdered="검색어를 입력하세요"
        @search-data="searchData"
      />
      <!-- 검색 영역 -->
    </div>
    <template v-if="isLoaded">
      <news-list-section
        :news-list="newsList"
        @move-to-detail="moveToDetail"
        v-if="newsList.length > 0"
      ></news-list-section>
      <news-empty-list v-else :searchText="searchText"></news-empty-list>
    </template>
    <!-- 페이징 영역-->
    <pagination
      v-model="pagingData.currentPage"
      :pageSize="pagingData.pageSize"
      :rangeSize="pagingData.rangeSize"
      :totalCount="pagingData.totalCount"
    />
  </div>
</template>

<script>
import SearchBox from '@/components/page/SearchBox.vue';
import Pagination from '@/components/page/Pagination.vue';
import NewsListSection from './NewsListSection.vue';
import NewsEmptyList from './NewsEmptyList.vue';

export default {
  name: 'NewsList',
  components: {
    SearchBox,
    Pagination,
    NewsListSection,
    NewsEmptyList,
  },
  props: {
    storedPageData: {
      type: Object,
      required: true,
    },
    pagingData: {
      type: Object,
      required: true,
    },
    searchText: {
      type: String,
      default: '',
    },
    newsList: {
      type: Array,
      required: true,
    },
    isLoaded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['search-news', 'move-to-detail'],
  methods: {
    // ## 뉴스 디테일 페이지 이동
    moveToDetail(newsId) {
      this.$emit('move-to-detail', newsId);
    },
    searchData(searchText) {
      this.$emit('search-news', searchText);
    },
    setSearchText(searchText) {
      this.$refs.searchBox.setInputText(searchText);
    },
  },
};
</script>

<style lang="scss" scoped>
.srch-wrap {
  &-box {
    width: 40rem;
    float: right;
    @media (max-width: $mobile-size) {
      width: 100%;
    }
  }
  &::after {
    @include clear-float;
  }
}
</style>
